import { motion } from "framer-motion";

/**
 * Reveal — scroll-triggered fade + rise. Once per element (viewport-once).
 * Usage:
 *   <Reveal><h2>…</h2></Reveal>
 *   <Reveal delay={0.1} as="section">…</Reveal>
 */
export function Reveal({ children, delay = 0, y = 24, as: Tag = "div", className = "", ...rest }) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

/**
 * Stagger — reveal children with a stagger delay.
 */
export function Stagger({ children, delay = 0, stagger = 0.08, className = "", ...rest }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={{ visible: { transition: { staggerChildren: stagger, delayChildren: delay } } }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export const StaggerItem = ({ children, y = 20, className = "", ...rest }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
    }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);
